































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudRc from "@/models/tramite/solicitud-reporte-comunitario/solicitudRc.model";
import Persona from "@/models/persona/persona.model";
import SituacionRc from "@/models/reporteComunitario/situacionRc.model";
import TipoTramite from "@/models/tipoTramite";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";

@Component
export default class SolicitudReporteComunitario extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;

  model: any = null;
  get tramiteBeneficiarioId() {
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }
  get situaciones() {
    if (!this.model) return [];
    return this.model.situacionesSeleccionadas.split(";");
  }
  async mounted() {
    if (this.tramiteBeneficiarioId) {
      this.model = await new BaseHttpClient(
        "TramiteBeneficiarioResumen"
      ).getAsync("GetSolicitudRc", {
        tramiteId: this.tramiteBeneficiarioId
      });
    }
  }
}
